import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4" data-id="element-164">
      <div className="max-w-3xl mx-auto bg-gradient-to-br from-brand-card to-brand-darker border border-brand-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-165">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent" data-id="element-166" />

        <ShieldCheck className="w-20 h-20 text-brand-gold mx-auto mb-6" data-id="element-167" />

        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-168">
          🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <p className="text-lg text-gray-300 mb-8 max-w-xl mx-auto" data-id="element-169">
          Abrís los tomos. Los usás en tu cocina. Si en 7 días no es lo que
          esperabas:
        </p>

        <div className="text-3xl font-bold text-brand-gold mb-8" data-id="element-170">
          Devolución del 100%
        </div>

        <p className="text-gray-400 mb-6" data-id="element-171">
          Sin formularios. Sin drama. Sin preguntas.
        </p>

        <div className="inline-block px-4 py-2 rounded-full bg-white/5 text-sm text-gray-300 border border-white/10" data-id="element-172">
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </section>;
}